import $ from 'jquery';
import selectV2 from '../select-v2/select-v2';
import { Changer } from '../../services/changer/Changer';
import MechanicTypeEnum from '../../enums/MechanicTypeEnum';
import { 
    globalConfig 
} from '../../scripts/config';

const catalogZoneV1Semantics = {
    'mainWrapClass': 'catalog-zone-v1',
    'formWrapClass': 'filter-form-v1__form',
    'sortPanelClass': 'catalog-filtered-grid__sort-panel',
    'sortSelectSelector': '.catalog-filtered-grid__sort-panel .select-v2 select',
    'sortMirrorFieldSelector': '.catalog-filtered-grid__sort-panel .catalog-filtered-grid__sort-mirror',
    'sortFieldName': 'sort',
    'currentFilterableBlockInputSelector': '[name="cfp"]',
    'filterableBlockWrapClass': 'catalog-filtered-grid__filter-block',
    'filterableBlockIdAttribute': 'data-filterable-block-id',
    'productGridWrapperSelector': '.catalog-filtered-grid__filter-panel .product-grid-v1__wrapper',
    'productGridWrapSelector': '.catalog-filtered-grid__filter-panel .product-grid-v1',
    'appliedTagListWrapSelector': '.catalog-filtered-grid__active-filter-panel .catalog-filtered-grid__applied-tag-list-wrap',
    'paginationWrapSelector': '.catalog-filtered-grid__sort-panel .pagination-summary-v1',
    'paginationShowCountClass': 'pagination-summary-v1__show-count',
    'paginationTotalCountClass': 'pagination-summary-v1__total-count',
    'activeFilterPanelWrapSelector': '.catalog-filtered-grid__active-filter-panel',
    'activeFilterPanelTrackedCancelSelector': '.filter-applied-tags-v1__cancel-icon',
    'activeFilterPanelTrackedWrapClass': 'filter-applied-tags-v1__item',
    'activeFilterPanelTrackedFilterableBlockSelectorAttribute': 'data-filterable-block-selector',
    'activeFilterPanelTrackedMechanicTypeAttribute': 'data-mechanic-type',
    'activeFilterPanelTrackedSearchableValue': 'data-searchable-value',
    'runnerWrapClass': 'runner-v1__wrap', 
};

$(function() {

    if ($(`.${catalogZoneV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    var catalogZoneV1 = new CatalogZoneV1();
    catalogZoneV1.initComponent();
    catalogZoneV1.subscribe();

});

class CatalogZoneV1
{

    /**
     * @var {jQuery|null}
     */
    mainWrapElement = null;

    /**
     * @var {jQuery|null}
     */
    formWrapElement = null;

    /**
     * @var {jQuery|null}
     */
    sortElement = null;

    /**
     * @var {jQuery|null}
     */
    sortMirrorElement = null;

    /**
     * @var {jQuery|null}
     */
    paginationElement = null;

    /**
     * @var {jQuery|null}
     */
    activeFilterPanelWrapElement = null;

    /**
     * @var {string}
     */
    preparedActionUrl = '';
    
    /**
     * @var {Array}
     */
    requestData = [];

    initComponent() {
        this.mainWrapElement = 
            $(`.${catalogZoneV1Semantics.mainWrapClass}`);
        this.formWrapElement = 
            this.mainWrapElement.find(`.${catalogZoneV1Semantics.formWrapClass}`);
        this.sortMirrorElement = 
            this.mainWrapElement.find(catalogZoneV1Semantics.sortMirrorFieldSelector);
        this.sortElement = 
            this.mainWrapElement.find(catalogZoneV1Semantics.sortSelectSelector);
        this.currentFilterableBlockInput = 
            this.mainWrapElement.find(catalogZoneV1Semantics.currentFilterableBlockInputSelector);
        this.paginationWrapElement = 
            this.mainWrapElement.find(catalogZoneV1Semantics.paginationWrapSelector);
        this.activeFilterPanelWrapElement = 
            this.mainWrapElement.find(catalogZoneV1Semantics.activeFilterPanelWrapElement);

        // TODO[needImpl]
        CatalogZoneV1.reInitChildPlugins();
    }

    /**
     * TODO[justMvp]: внедрить универсальное решение
     * для переинициализации любых дочерних js-плагинов
     * внутри родительских
     * @return void
     */
    static reInitChildPlugins(
        timeout = 1000
    ) {
        setTimeout(() => {
            if (window.widgets.galleryV3) {
                window.widgets.galleryV3.resetInitialized(
                    $(`.${catalogZoneV1Semantics.mainWrapClass}`)
                );
                window.widgets.galleryV3.initAll(
                    $(`.${catalogZoneV1Semantics.mainWrapClass}`)
                );
            }
        }, timeout);
    }

    subscribe() {

        let self = this;

        // change filter form
        $(document).on(
            'change', 
            `.${catalogZoneV1Semantics.formWrapClass}`, 
            function(e) {
                self.filterRequest();
            }
        );

        // change sort
        $(document).on(
            'change', 
            catalogZoneV1Semantics.sortSelectSelector, 
            function(e) {
                $(catalogZoneV1Semantics.sortMirrorFieldSelector).val(
                    $(this).val()
                );
                self.filterRequest();
            }
        );

        // change concrete filterableBlock
        $(document).on(
            'change',
            `.${catalogZoneV1Semantics.filterableBlockWrapClass} :input`,
            function(e) {
                let filterableBlockWrap = 
                    $(e.target).closest(`.${catalogZoneV1Semantics.filterableBlockWrapClass}`);
                let noEmptyValue = filterableBlockWrap.find(':input').filter(function(index, element) {
                    return $(element).val() != '';
                });
                if (noEmptyValue.length) {
                    self.currentFilterableBlockInput.val(
                        filterableBlockWrap.attr(catalogZoneV1Semantics.filterableBlockIdAttribute)
                    );
                }
            }
        );

        // cancel applied tag's
        $(document).on(
            'click',
            `${catalogZoneV1Semantics.activeFilterPanelWrapSelector} ${catalogZoneV1Semantics.activeFilterPanelTrackedCancelSelector}`,
            function(e) {
                self.cancelAppliedTag(e);
            }
        );

    }

    cancelAppliedTag(e) {
        let self = this;
        let target = $(e.target);
        let cancelElement = target
            .closest(`.${catalogZoneV1Semantics.activeFilterPanelTrackedWrapClass}`);
        
        let fb = self.mainWrapElement.find(
            cancelElement.attr(
                catalogZoneV1Semantics
                    .activeFilterPanelTrackedFilterableBlockSelectorAttribute
            )
        );
        switch (
            cancelElement.attr(
                catalogZoneV1Semantics
                    .activeFilterPanelTrackedMechanicTypeAttribute
            )
        ) {
            case MechanicTypeEnum.aggregator.description:
                fb.find(':input').val('');
            break;
            case MechanicTypeEnum.option.description:
                fb.find(`:input[value="${cancelElement.attr(
                    catalogZoneV1Semantics
                        .activeFilterPanelTrackedSearchableValue
                )}"]`).trigger('click');
            break;
            case MechanicTypeEnum.range.description:
                fb.find(':input').val('');
                let runner = fb.find(`.${catalogZoneV1Semantics.runnerWrapClass}`)[0] ?? null;
                if (runner) {
                    runner.noUiSlider.set([
                        $(runner).data('min-value'),
                        $(runner).data('max-value')
                    ]);
                }
            break;
        }
        self.formWrapElement.trigger('change');
    }

    addFilterFormDataToRequest() {

        let self = this;

        self.requestData = self.requestData.concat(
            self.formWrapElement.find(':input')
                .filter(function(index, element) {
                    return $(element).val() != '';
                })
                .serializeArray()
        );
    }

    addSortDataToRequest() {
        let self = this;
        if (self.sortMirrorElement.val() != '') {
            self.requestData.push({
                name: self.sortElement.attr('name'),
                value: self.sortMirrorElement.val(),
            });
        }
    }

    collectRequestData() {
        let self = this;
        self.requestData = [];
        self.addFilterFormDataToRequest();
        self.addSortDataToRequest();
        // алгоритм сортировки не играет роли, главное
        // чтобы параметры всегда были в одном порядке
        // для дальнейшего поиска соответствия на сервере
        self.requestData.sort();
    }

    filterRequest() {
        let self = this;
        self.collectRequestData();
        self.prepareActionUrl();
        // add CSRF-token
        // self.requestData.push(CsrfToken);

        self.mainWrapElement.find('.page-preloader').show();

        $.get({
            url: self.preparedActionUrl,
            method: 'GET',
        }).done(function(data) {
            self.mainWrapElement.find('.page-preloader').hide();
            self.mainWrapElement.find(
                catalogZoneV1Semantics.productGridWrapperSelector
            ).replaceWith(data.productGridContent);
            self.mainWrapElement.find(
                catalogZoneV1Semantics.appliedTagListWrapSelector
            ).empty().html(data.appliedTagListContent);
            self.updatePagination(data.pagination);
            self.updateFilterFormAppliedTagLists(data.appliedTagListsByFilterableBlock);
            self.updateFilterFormSmartSystem(data.filterForm);
            self.pluginReinit();
            self.changeCurrentUrl(data.redirectUrl);
        })
    }

    updatePagination(pagination) {
        let self = this;
        self.paginationWrapElement.find(
            `.${catalogZoneV1Semantics.paginationShowCountClass}`
        ).empty().html(pagination.showCount);
        self.paginationWrapElement.find(
            `.${catalogZoneV1Semantics.paginationTotalCountClass}`
        ).empty().html(pagination.totalCount);
    }

    updateFilterFormAppliedTagLists(lists) {

        if (!Object.keys(lists).length) {
            return;
        }

        for (let elementKey in lists) {
            let element = lists[elementKey];
            if ($(element.selector).length) {
                $(element.selector).empty().html(
                    element.content
                );
            }
        }

    }

    updateFilterFormSmartSystem(filterForm) {

        let filters = filterForm?.filters ?? null;

        if (!Object.keys(filters).length) {
            return;
        }

        for (let filterKey in filters) {

            let filter = filters[filterKey];
            let jsChanges = filter.jsChanges;
            if (!Array.isArray(jsChanges) || !jsChanges.length) {
                continue;
            }
    
            let changer = new Changer();
            changer.isLog = globalConfig.isDebugMode;
            changer.rawChanges = jsChanges;
            changer.buildChanges();
            changer.runChanges();
        }

    }

    prepareActionUrl() {
        let self = this;
        self.preparedActionUrl = '';
        let url = new URL(this.formWrapElement.attr('action'), window.location.origin);
        let searchParams = url.searchParams;
        self.requestData.forEach((el) => {
            searchParams.append(el.name, el.value);
        });
        self.preparedActionUrl = decodeURIComponent(url.toString());
    }

    pluginReinit() {
        let self = this;
        selectV2.initAll();
        CatalogZoneV1.reInitChildPlugins(1000);
        // window.widgets.galleryV3.initAll();
        window.widgets.productShowMoreV1.initAll();
    }

    changeCurrentUrl(url) {
        // let self = this;
        // let url = new URL(document.location);
        // let searchParams = url.searchParams;

        // // delete all filter/sort/pagination params
        // let regexp = new RegExp(/^fp(.*)$/g);
        // searchParams.forEach((value, key) => {
        //     // if (regexp.test(key)) {
        //         // TODO[fastImpl]: delete all param's
        //         searchParams.delete(key);
        //     // }
        // });
        // // searchParams.delete("cfp");
        // // searchParams.delete("page");
        // // searchParams.delete("per-page");
        // // searchParams.delete("sort");
        // // \delete all filter/sort/pagination params

        // self.requestData.forEach(function(el) {
        //     if (el.name == $('meta[name=csrf-param]').prop('content')) {
        //         return;
        //     }
        //     searchParams.append(el.name, el.value);
        // });
        // console.log(url);
        if (location.protocol == 'https:') {
            url = url.replace('http://', 'https://');
        }
        window.history.pushState({}, '', decodeURI(url));
    }
    
}

